"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EmailBodySkeleton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var EmailBodySkeleton = exports.EmailBodySkeleton = function EmailBodySkeleton() {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "skeleton bg-secondary dark:bg-card w-full h-6"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "skeleton bg-secondary dark:bg-card w-full h-6 mt-4"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "skeleton bg-secondary dark:bg-card w-full h-14 mt-4"
  }));
};
var _default = exports["default"] = function _default(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = 'skeleton bg-secondary dark:bg-card';
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: "relative overflow-hidden m-2",
    style: {
      boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 30px'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-4 pt-5 mb-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('h-14 w-14 rounded-full flex-shrink-0', classes)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('h-4 w-32 ml-4', classes)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('h-5 w-full', classes)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-2 mb-2 mx-auto",
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: style.width * 0.9,
      minHeight: 500
    })
  }, /*#__PURE__*/_react["default"].createElement(EmailBodySkeleton, null)));
};
//# sourceMappingURL=ThreadFeedItem.js.map